/* src/modules/discounts/cards/AddDiscountCard/styles.js */

export default theme => ({
  paper: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: theme.spacing.unit * 82,
    transform: 'translate(-50%, -50%)',
  },
  space: {
    height: theme.spacing.unit * 3,
  },
  collapse: {
    paddingLeft: theme.spacing.unit * 3,
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  typeFormControl: {
    width: theme.spacing.unit * 20,
    marginRight: theme.spacing.unit * 2,
  },
  content: {
    padding: theme.spacing.unit * 3,
    position: 'relative',
  },
  amountField: {
    width: theme.spacing.unit * 32,
  },
  textField: {
    width: theme.spacing.unit * 20,
    marginRight: theme.spacing.unit * 2,
  },
  buttonContainerDone: {
    display: 'flex',
    flexDirection: 'row-reverse',
    paddingTop: theme.spacing.unit * 3,
  },
  buttonIcon: {
    marginRight: theme.spacing.unit,
  },
});



// WEBPACK FOOTER //
// ./src/modules/discounts/cards/AddDiscountCard/styles.js